import { BaseRouteReuseStrategy } from '@angular/router';

export class NoReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(): boolean {
        return false;
    }
}
